export const AGENT_POOL_TABS = ['processor', 'singlecam', 'media-agent'] as const;

export type AgentPoolTab = (typeof AGENT_POOL_TABS)[number];

export function isAgentPoolTab(value: string | undefined): value is AgentPoolTab {
  return AGENT_POOL_TABS.includes(value as AgentPoolTab);
}

export function agentPoolsTabPath(tab: AgentPoolTab): string {
  return `/admin/agents/${tab}`;
}
